import {NavigationConfig, NavigationItem} from '@common-ui-lib';
import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export abstract class NavigationProviderService {
  public abstract get navigationConfig(): NavigationConfig;

  public abstract get navigationPages(): Array<NavigationItem>;
}
